// Copyright (c) 2026 Chain Capital Technologies Ltd. All rights reserved.
// See LICENSE file in the project root for full license information.

const SATS_PER_BTC = 100_000_000;

/** Format a satoshi amount as a fixed 8-decimal BTC string, e.g.
 *  `10_000_000 → "0.10000000"`, `10_959 → "0.00010959"`. Mirrors the
 *  user-app SPA's `formatBtc` so every user-facing Cobault surface
 *  presents amounts in BTC consistently (COB-149). */
export function formatBtc(sats: number): string {
  return (sats / SATS_PER_BTC).toFixed(8);
}
